import { isApprovedAttributeReviewStatus } from "./reviewQueueStatus";

// Kinds whose value the server fills itself (SKU, units). We decide these names.
const FILLED_BY_US = new Set(["system field", "unit only"]);

export const isFilledByUs = (kind: unknown) => FILLED_BY_US.has(String(kind));

export const noFieldTarget = (kind: string, store: string) =>
  kind === "one store only"
    ? `a ${store}-only field`
    : FILLED_BY_US.has(kind)
      ? "a system field"
      : "no SmartStore field";

export const noFieldNote = (kind: string) =>
  FILLED_BY_US.has(kind)
    ? "The server fills it. The seller never types it."
    : null;

export const saveTargetName = (
  noFieldKind: string | null,
  store: string,
  pick: { picked: boolean; linkMode: boolean; toName: string; label: string },
) =>
  noFieldKind
    ? noFieldTarget(noFieldKind, store)
    : !pick.picked
      ? null
      : pick.linkMode
        ? pick.toName
        : `“${pick.label}”`;

type Draft = { kind?: string; leaf?: string; path?: string | null };

type Row = {
  path?: unknown;
  leaf?: unknown;
  kind?: unknown;
  decisionStatus?: unknown;
};

// A draft path of null means ops picked an answer with no field.
export function pickedOf(
  row: Row,
  draft: Draft | undefined,
  fieldless: (kind: string) => boolean,
) {
  const pathPicked = draft?.path !== undefined;
  return {
    pickedPath: pathPicked
      ? (draft.path ?? null)
      : ((row.path as string | null) ?? null),
    pickedLeaf:
      pathPicked && draft.path !== row.path
        ? (draft.leaf ?? null)
        : (draft?.leaf ?? (row.leaf as string | null) ?? null),
    noFieldKind:
      draft?.path === null
        ? draft.kind && fieldless(draft.kind)
          ? draft.kind
          : null
        : !pathPicked &&
            !row.path &&
            !row.leaf &&
            isApprovedAttributeReviewStatus(row.decisionStatus)
          ? ((row.kind as string | null) ?? null)
          : null,
  };
}
